<template>
  <div class="multipleSchoolSet">
    <a-form-model layout="inline" style="display: flex; justify-content: space-around">
      <a-form-model-item label="校内学生一致">
        <a-switch v-model="uniformity.schoolUniformity" :loading="switchLoading" :disabled="IsDetails" @change="switchChange" checked-children="启用" un-checked-children="禁用" />
      </a-form-model-item>
      <a-form-model-item v-if="tableRelevant.tableDataSource.some((s) => s.items.length)">
        <a-dropdown :trigger="['click']" v-model="dropdownVisible" :disabled="IsDetails">
          <a-button @click="(e) => e.preventDefault()">快速配置学生</a-button>
          <a-menu slot="overlay">
            <!-- <a-menu-item key="0" @change="change0">
              <a-checkbox value="0" v-model="checkboxs.a">未开始</a-checkbox>
            </a-menu-item> -->
            <a-menu-item key="1" @change="change0">
              <a-checkbox value="1" v-model="checkboxs.b">进行中</a-checkbox>
            </a-menu-item>
            <a-menu-item key="2" @change="change0">
              <a-checkbox value="2" v-model="checkboxs.c">已完成</a-checkbox>
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item>
              <a-button style="margin-right: 15px" @click="quickSetClose()">取消</a-button>
              <a-button type="primary" @click="quickSet()" :disabled="quickSetStudent.length < 1">确定</a-button>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </a-form-model-item>
      <a-form-model-item v-if="tableRelevant.tableDataSource.some((s) => s.items.length)">
        <a-button @click="resetComputed()" :disabled="IsDetails">重新算分</a-button>
      </a-form-model-item>
      <a-form-model-item v-if="!IsDetails">
        <a-button :loading="addRoundLoading" @click="addRound" :disabled="IsDetails" type="primary">添加测评轮次</a-button>
      </a-form-model-item>
    </a-form-model>
    <div style="margin: 30px auto; width: 95%">
      <a-table :columns="columns" row-key="groupReportSampleId" :pagination="false" :loading="tableRelevant.tableLoading" :dataSource="tableRelevant.tableDataSource">
        <div slot="sampleName" slot-scope="text">
          <span v-if="!text.isEdit">
            {{ text.groupReportSampleName }}
            <a-icon @click="text.isEdit = true" v-if="!IsDetails" style="cursor: pointer; margin-left: 10px" type="edit" />
          </span>
          <input v-else @blur="tableInputBlurRound(text, $event)" class="table-input" :value="text.groupReportSampleName" />
        </div>
        <div slot="student" slot-scope="text">{{ text.settingUserCount || 0 }}/{{ text.courseChildUserCount || 0 }}</div>
        <div slot="action" class="action" slot-scope="text">
          <a @click="addCourse(text)">添加测评</a>
          <a-popconfirm title="确认删除此测评轮次？" @confirm="delAssessRound(text)">
            <a class="red">删除</a>
          </a-popconfirm>
        </div>
        <StepsSecondCourse
          compare="2"
          slot-scope="text"
          :tablePagination="false"
          :organization="true"
          :IsDetails="IsDetails"
          @renewData="getGroupReportCourseInfo"
          :uniformity="uniformity"
          slot="expandedRowRender"
          :tableDataSource="text.items"
        />
      </a-table>
    </div>

    <!-- 添加测评 -->
    <a-modal v-model="course.visible" title="添加测评" width="70%" @ok="courseSubmit" :confirm-loading="course.confirmLoading" :destroyOnClose="true">
      <StepsSecondAddCourse :select-data="selectTableData" :key="assessRoundItem.groupReportSampleId" ref="addCourse" />
    </a-modal>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import StepsSecondCourse from '@/pages/reportCenter/groupReport_new/components/StepsSecondCourse'
import StepsSecondAddCourse from '@/pages/reportCenter/groupReport_new/components/StepsSecondAddCourse'

export default {
  name: 'MultipleSchoolSet',
  props: {
    IsDetails: {
      type: Boolean,
      default: false,
    },
  },
  components: { StepsSecondCourse, StepsSecondAddCourse },
  data() {
    return {
      uniformity: {
        schoolUniformity: this.$store.getters['organization/getReportInfo'].studentSampleTakingMethod === 2,
        sampleInsideUniformity: undefined,
        sampleOutsideUniformity: undefined,
      },
      addRoundLoading: false,
      columns: [
        { title: '测评轮次', scopedSlots: { customRender: 'sampleName' } },
        { title: '学生数', scopedSlots: { customRender: 'student' } },
        { title: '操作', scopedSlots: { customRender: 'action' } },
      ],
      tableRelevant: tableRelevant.call(this),
      tableExpandedRowKeys: [], //表格展开的行
      selectTableData: [],
      assessRoundItem: {},
      switchLoading: false,
      course: {
        visible: false,
        confirmLoading: false,
      },
      dropdownVisible: false,
      quickSetStudent: [],
      checkboxs: {
        a: false,
        b: false,
        c: false,
      },
    }
  },
  watch: {
    dropdownVisible(val) {
      if (!val) {
        this.quickSetStudent = []
        this.checkboxs = {
          a: false,
          b: false,
          c: false,
        }
      }
    },
  },
  mounted() {
    if (this.IsDetails && this.columns.length > 2) {
      this.columns.pop()
    }
    this.getGroupReportCourseInfo()
  },
  methods: {
    change0(e) {
      if (e.target.checked) {
        this.quickSetStudent.push(+e.target._value)
      } else {
        this.quickSetStudent = this.quickSetStudent.filter((f) => f != e.target._value)
      }
    },
    quickSetClose() {
      this.dropdownVisible = false
      this.quickSetStudent = []
      this.checkboxs = {
        a: false,
        b: false,
        c: false,
      }
    },
    // 快速配置学生
    quickSet() {
      let params = {
        groupReportId: this.$store.getters['organization/getReportInfo'].id,
        userCourseSessionStatus: this.quickSetStudent,
      }
      this.$http.ReportService.configGroupStudent(params).then((res) => {
        this.$message.destroy()
        const { status, data, message } = res
        this.$message.success(message)
        this.getGroupReportCourseInfo()
        this.dropdownVisible = false
        this.quickSetStudent = []
        this.checkboxs = {
          a: false,
          b: false,
          c: false,
        }
      })
    },
    // 重新算分
    resetComputed() {
      let that = this
      this.$confirm({
        title: '确认重新算分?',
        content: '重新算分后原有分数将被清空，请确认此操作',
        onOk() {
          let formData = new FormData()
          that.tableRelevant.tableDataSource.forEach((v) => {
            v.items.forEach((i) => {
              formData.append('customerChildCourseIds', i.groupReportCourseSessionId)
              formData.append('customerCourseIds', i.organizationCourseId)
            })
          })
          that.$http.GroupReport.GroupReportUpdateCourseContentScore(formData).then((res) => {
            that.$message.destroy()
            const { status, data, message } = res
              that.$message.success(message)

          })
        },
        onCancel() {},
      })
    },
    switchChange(checked) {
      const reportInfo = this.$store.getters['organization/getReportInfo']
      const Params = {
        groupReportId: reportInfo.id,
        studentSampleTakingMethod: checked ? 2 : 0,
      }
      this.switchLoading = true
      this.$http.GroupReport.updateStudentSampleTakingMethod(Params).then((res) => {
        const { status, data, message } = res
          this.$message.success(message)
          this.getGroupReportCourseInfo()
          this.$store.commit('organization/setReportInfo', {
            ...reportInfo,
            studentSampleTakingMethod: Params.studentSampleTakingMethod,
          })

      }).catch(e => {
        this.switchLoading = false
      })
    },
    addRound() {
      const Form = new FormData()
      Form.append('sampleName', `第${this.tableRelevant.tableDataSource.length + 1}次测评`)
      Form.append('groupReportId', this.$store.getters['organization/getReportInfo'].id)
      this.addRoundLoading = true
      this.$http.ReportService.updateGroupReportSample(Form)
        .then((res) => {
          const { status, message } = res
          this.$message.success(message)
          this.getGroupReportCourseInfo()
        })
        .finally(() => (this.addRoundLoading = false))
    },

    // 修改自定义测评轮次
    tableInputBlurRound(val, ev) {
      if (val.groupReportSampleName === ev.target.value) {
        val.isEdit = false
        return
      }
      const Form = new FormData()
      Form.append('id', val.groupReportSampleId)
      Form.append('sampleName', ev.target.value)
      Form.append('groupReportId', this.$store.getters['organization/getReportInfo'].id)
      val.isEdit = false
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.updateGroupReportSample(Form)
        .then((res) => {
          const { status, message } = res
          this.$message.success(message)
          this.getGroupReportCourseInfo()
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
    addCourse(val) {
      this.assessRoundItem = val
      this.selectTableData = val.items.map((m) => m.projectCourseChildId)
      this.course.visible = true
    },
    // 删除测评轮次
    delAssessRound(val) {
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.delGroupReportSample({ id: val.groupReportSampleId })
        .then((res) => {
          const { status, message } = res
          this.$message.success(message)
          this.getGroupReportCourseInfo()
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
    // 添加测评
    courseSubmit() {
      this.$message.destroy()
      if (!this.$refs.addCourse.selectedRowKeys.length) {
        this.$message.warning('请选择测评')
        return
      }
      const RequestBody = this.$refs.addCourse.selectedRows.map((m) => {
        return {
          groupReportId: this.$store.getters['organization/getReportInfo'].id,
          groupReportSampleId: this.assessRoundItem.groupReportSampleId,
          organizationId: m.organizationId,
          organizationCourseId: m.projectCourseConfigId,
          organizationCourseSessionId: m.id,
        }
      })
      const params = {
        groupReportId: this.$store.getters['organization/getReportInfo'].id,
        params: RequestBody,
      }
      this.course.confirmLoading = true
      this.$http.ReportService.addGroupReportCourse(params)
        .then((res) => {
          const { status, data, message } = res
          this.course.visible = false
          this.$message.success(message)
          this.getGroupReportCourseInfo()
        })
        .finally(() => {
          this.course.confirmLoading = false
        })
    },
    // 获取团体报告配置课程信息
    getGroupReportCourseInfo() {
      const reportId = this.$store.getters['organization/getReportInfo'].id
      if (!reportId) return
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.getGroupReportSample(reportId)
        .then((res) => {
          this.addRoundLoading = false
          this.switchLoading = false
          const { data } = res
          this.tableRelevant.tableDataSource = data.map((m, i) => {
            m.isEdit = false
            m.index = i
            return m
          })
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
  },
}
</script>

<style scoped>
.multipleSchoolSet /deep/ tr.ant-table-expanded-row {
  background-color: transparent;
}

.table-input {
  border: none;
  width: 100%;
  height: 100%;
  display: block;
  background: transparent;
  outline: none;
  text-align: left;
}
</style>
